import { gql } from '@apollo/client';

export const GET_ASSIGNMENT_FILTERS = gql`
  query SkWeb_AssignmentFilters($schoolId: ID) {
    schools {
      id
      name
      classrooms {
        id
        name
        courses {
          invalid
          level
          product {
            id
            name
            payable
            freebie
          }
        }
      }
    }
    teachers {
      id
      name
    }
    classrooms(schoolId: $schoolId) {
      id
      name
      courses {
        invalid
        level
        product {
          id
          name
          payable
          freebie
        }
      }
    }
  }
`;
